module.exports = __webpack_public_path__ + "static/media/gamification.0132b7a6.jpg";